import { render } from "./sales-discount.vue?vue&type=template&id=2c78baec"
import script from "./sales-discount.vue?vue&type=script&lang=js"
export * from "./sales-discount.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__